module.exports = __webpack_public_path__ + "img/aboutEquipmentmonitoring.f8a00263.jpg";